'use client';

import dynamic from 'next/dynamic';

/**
 * Client-only wrapper for cookie-dependent sections.
 * Uses dynamic imports with ssr: false to ensure these components
 * only render on the client, avoiding hydration mismatches.
 *
 * Note: LandingSection is NOT included here - it renders on the server
 * for SEO and to reduce layout shift.
 */

const UpcomingBookingsWrapper = dynamic(
  () => import('./UpcomingBookingsWrapper').then((mod) => mod.UpcomingBookingsWrapper),
  { ssr: false }
);

export function ClientOnlyUpcomingBookings() {
  return <UpcomingBookingsWrapper />;
}
